import { Box } from '@mui/material';

export type ScrollPositionProps = {
  id: string;
  top?: number;
};

export function ScrollPosition({ id, top = 200 }: ScrollPositionProps) {
  return (
    <Box position="relative">
      <Box id={id} position="absolute" top={-top} />
    </Box>
  );
}
